import type { DataResponse } from '@/types/DataResponse';
import type { Notification } from '../types';

export default function useNotifications() {
  const { data, execute, pending } = useGetData<DataResponse<Notification[]>>();
  const { data: dataPatch, execute: executePatch } = useSubmit<DataResponse<Notification>>();
  const notificationStore = useNotificationStore();

  const getNotifications = async (page: number) => {
    await execute(`notifications?include=notifiable&page=${page}`);
  };

  const read = async (id: string) => {
    await executePatch('notifications', {
      method: 'PUT',
      body: {
        notification_id: id,
      },
    });
  };

  return {
    data,
    pending,
    getNotifications,
    read,
    unreadCount: notificationStore.unreadCount,
    fetchUnreadCount: notificationStore.fetchUnreadCount,
  };
}
